export const isPromise = <U>(obj: U | PromiseLike<U>): obj is PromiseLike<U> =>
  !!obj && !!(obj as Promise<U>).then;

export async function handleAsyncCallback<T>(
  callback: () => T | Promise<T>,
  options?: {
    onSuccess?: () => void;
    onError?: (error: unknown) => void;
    devLoggingEnabled?: boolean;
  }
): Promise<T | void> {
  try {
    const result = callback();

    if (isPromise(result)) {
      const resolvedResult = await result;
      if (options?.onSuccess) {
        options.onSuccess();
      }
      return resolvedResult;
    }

    if (options?.onSuccess) {
      options.onSuccess();
    }

    return result;
  } catch (error) {
    //don't throw error, let the component handle gracefully
    if (options?.devLoggingEnabled && process.env.NODE_ENV !== "production") {
      console.warn("Component library async callback error:", error);
    }
    if (options?.onError) {
      try {
        options.onError(error);
      } catch (onErrorCbError) {
        if (
          options?.devLoggingEnabled &&
          process.env.NODE_ENV !== "production"
        ) {
          console.warn(
            "Component library async callback onError error:",
            onErrorCbError
          );
        }
      }
    }
    return;
  }
}
